/** The filters of the app lists; each one holds the selected option values. */
export type AppFilters = {
  spaces: string[];
  owners: string[];
  /** `published` / `unpublished` */
  status: string[];
  /** `editable` / `readonly` */
  access: string[];
};

export const EMPTY_APP_FILTERS: AppFilters = { spaces: [], owners: [], status: [], access: [] };
